module.exports = __webpack_public_path__ + "static/img/2.340abb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/rongyao/2.png
// module id = avug
// module chunks = 0